'use strict';

var React = require('react');
var Grid = require('../../Layout/Grid/Grid.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * By grouping ChatBubbles together we can display the chat nubby tail only on
 * the last one of each thread without needing to employ complex logic.
 * (By Ian's request)
 */

var ChatBubbleGroup = function ChatBubbleGroup(_ref) {
  var children = _ref.children;
  return React__default["default"].createElement(Grid, {
    container: true
  }, children);
};

module.exports = ChatBubbleGroup;
